import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'pages.feedbackRequests.feedbackRequests',
    defaultMessage: 'Feedback Requests',
  },
});
